import React from 'react'
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';

const CanMappingTabing = ({value}) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider',mb:3 }}>
        <Button className={`tabingButton ${value === 'constant-messages' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/can/constant-messages">ECU Constant TxMessages</Button>
        <Button className={`tabingButton ${value === 'definitions' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/can/definitions">ECUID Definitions</Button>
        <Button className={`tabingButton ${value === 'request-pgn' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/can/request-pgn">ECU Request PGN</Button>
        <Button className={`tabingButton ${value === 'receive-messages' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/can/receive-messages">ECU Receive Messages</Button>
        <Button className={`tabingButton ${value === 'transmit-messages' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/can/transmit-messages">ECU Transmit Messages</Button>
    </Box>
  )
}

export default CanMappingTabing